//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Amount

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The resale config model
* 
* @param addressNeeded ...
* @param productPrice 
* @param resaleMaxDate ...
* @param resaleMaxPrice 
* @param resaleMinPrice 
* @param resalePresaleFeePercent The presale fee in percent
* @param ticketId ...
*/
@Serializable

data class ResaleConfig (


      /* ... */
    @SerialName(value = "addressNeeded") @Required val addressNeeded: kotlin.Boolean,


      @SerialName(value = "productPrice") @Required val productPrice: Amount,


      /* ... */
    @SerialName(value = "resaleMaxDate") @Required val resaleMaxDate: kotlin.time.Instant,


      @SerialName(value = "resaleMaxPrice") @Required val resaleMaxPrice: Amount,


      @SerialName(value = "resaleMinPrice") @Required val resaleMinPrice: Amount,


      /* The presale fee in percent */
    @SerialName(value = "resalePresaleFeePercent") @Required val resalePresaleFeePercent: kotlin.Double,


      /* ... */
    @SerialName(value = "ticketId") @Required val ticketId: kotlin.Int


) {




  }

